import { ComponentProps, FC } from 'react';
import { Skeleton } from 'antd';

import SkeletonFade from '../SkeletonFade';

interface BaseSkeletonProps extends ComponentProps<typeof Skeleton> {
    fade?: boolean;
}

const cx = (...classes: Array<string | false | null | undefined>) => classes.filter(Boolean).join(' ');

const BaseSkeleton: FC<BaseSkeletonProps> = ({
    active = true,
    avatar = false,
    className,
    fade = false,
    round = true,
    ...props
}) => {
    const normalizedAvatar = avatar === true ? { shape: 'circle' as const } : avatar;
    const skeleton = (
        <>
            <style>
                {`
                    .cc-base-skeleton-avatar-center.ant-skeleton-with-avatar .ant-skeleton-header,
                    .cc-base-skeleton-avatar-center.ant-skeleton-with-avatar .ant-skeleton-content {
                        vertical-align: middle;
                    }
                `}
            </style>
            <Skeleton
                active={active}
                avatar={normalizedAvatar}
                className={cx(avatar && 'cc-base-skeleton-avatar-center', className)}
                round={round}
                {...props}
            />
        </>
    );

    return fade ? <SkeletonFade>{skeleton}</SkeletonFade> : skeleton;
};

export default BaseSkeleton;
